export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11278.aece9598.jpg";